import { render, staticRenderFns } from "./RequestPoliciesForm.vue?vue&type=template&id=763b00ec&scoped=true&"
import script from "./RequestPoliciesForm.vue?vue&type=script&lang=js&"
export * from "./RequestPoliciesForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestPoliciesForm.vue?vue&type=style&index=0&id=763b00ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b00ec",
  null
  
)

export default component.exports